module.exports = __webpack_public_path__ + "static/media/luma-banner-100.51d341e2.png";